import { Container, Flex, Icon, theme } from '@energiebespaarders/symbols';
import { useIsMobile } from '@energiebespaarders/symbols/hooks';
import { Logomark } from '@energiebespaarders/symbols/icons/custom';
import styled from 'styled-components';
import type { fetchCampaignBySlug_allCampaigns_navbar } from '~/types/generated/cms/fetchCampaignBySlug';
import { MinimalNav, StyledLogo } from './StyledComponents';
import DEBLogo from '/public/img/logo_WEB.svg';

interface Props {
  block: fetchCampaignBySlug_allCampaigns_navbar;
}

export const NavbarContainer = styled(Flex)`
  position: relative;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${theme.colors.grayLight};
  height: 70px;
`;

const NavBarblock: React.FC<Props> = ({ block }) => {
  const isMobile = useIsMobile();

  return (
    <MinimalNav width={1} p={2}>
      <Container
        size="md"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          height: '100%',
        }}
      >
        {!block.hideDebLogo &&
          (isMobile ? (
            <Icon icon={Logomark} fill="green" width="60px" />
          ) : (
            <StyledLogo src={DEBLogo} alt="Energiebespaarders logo" />
          ))}
        {block.logo?.url && <StyledLogo src={block.logo.url} alt="" />}
      </Container>
    </MinimalNav>
  );
};

export default NavBarblock;
